<h2 mat-dialog-title>Add Work Order Details</h2>

<div mat-dialog-content>
  <form [formGroup]="remarkForm">
    <mat-form-field appearance="outline" class="w-100 mt-2">
      <mat-label>PO #</mat-label>
      <input
        matInput
        formControlName="purchaseOrderNumber"
        placeholder="Enter PO Number"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Remark</mat-label>
      <textarea
        matInput
        formControlName="remarks"
        rows="4"
        placeholder="Enter your remark (optional)"
      ></textarea>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>

  <button
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="remarkForm.invalid"
  >
    Submit
  </button>
</div>